import currencyFormatter from '~/utils/currencyFormatter';

export const DEFAULT_CURRENCY = 'AUD';

export function normaliseDealOptionText(value: string | null | undefined) {
  const trimmedValue = value?.trim();
  return trimmedValue || undefined;
}

export function formatDealOptionValue(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return String(value);
}

export function parseDealOptionNumber(value: string | number | null | undefined) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }

  if (typeof value !== 'string' || !value.trim()) {
    return undefined;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
}

export function formatDealOptionCurrency(currency: string, value: string | number | null | undefined) {
  const parsedValue = parseDealOptionNumber(value);

  return parsedValue === undefined ? '—' : currencyFormatter(currency || DEFAULT_CURRENCY, parsedValue, 2);
}

export function formatDealOptionPercent(value: string | number | null | undefined) {
  const parsedValue = parseDealOptionNumber(value);

  return parsedValue === undefined ? '—' : `${parsedValue.toFixed(1)}%`;
}

export function formatAllocation(value: string | number | null | undefined) {
  const parsedValue = parseDealOptionNumber(value);

  return parsedValue === undefined ? '—' : String(parsedValue);
}
